import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { TableOutline } from '../../elements'
import { oAuthUrl, programOAuthTableHeadings } from './constant'
import { developerHubService, programService } from '../../Services'
import { useStyles } from './style'
import { Box, Popover, Tooltip, Typography } from '@material-ui/core'
import _ from 'lodash'
import { Loader } from '../../Components'
import copy from '../../Assets/Images/copy.svg'
import eye from '../../Assets/Images/eye.svg'
import hideeye from '../../Assets/Images/hideeye.svg'
import { InfoOutlined } from '@material-ui/icons'

const ProgramOAuth = (props) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [allPrograms, setAllPrograms] = useState([])
  const [programs, setPrograms] = useState([])
  const [showSecret, setShowSecret] = useState([])
  const [tableData, setTableData] = useState([])
  const [infoAnchorEl, setInfoAnchorEl] = useState(null)

  const { currentUser, setOpen, setMessage, setMessageType, messageTypes, copyToClipboard, isSuperAdmin, setShowProgramOAuthCard } = props

  const handleInfoClick = (event) => {
    setInfoAnchorEl(event.currentTarget)
  }

  const handleInfoClose = () => {
    setInfoAnchorEl(null)
  }

  const openInfo = Boolean(infoAnchorEl)
  const infoId = openInfo ? 'dropsown-popover' : undefined

  const getAllPrograms = () => {
    setLoading(true)
    programService.getAllAvailablePrograms(currentUser.account_id)
      .then(programsData => {
        const oAuthPrograms = programsData.filter(program => program.oauth_client_id && props.accountId === program.account_id)
        setPrograms(oAuthPrograms)
        setShowProgramOAuthCard(oAuthPrograms.length > 0)
        setAllPrograms(programsData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const filterPrograms = () => {
    const oAuthPrograms = allPrograms.filter(program => program.oauth_client_id && props.accountId === program.account_id)
    setPrograms(oAuthPrograms)
    setShowProgramOAuthCard(oAuthPrograms.length > 0)
  }

  const getClientSecret = (clientId, programId, index, oAuthPrograms) => {
    setLoading(true)
    developerHubService.getClientSecret(currentUser.account_id, props.accountId, clientId, isSuperAdmin)
      .then(clientSecretData => {
        const data = oAuthPrograms.map(obj => {
          if (obj.id === programId) {
            obj.oauth_client_secret = clientSecretData.oauth_secret_key
          }
          return obj
        })
        setPrograms(data)
        toggleSecretVisibility(index)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const toggleSecretVisibility = (index) => {
    let secretVisibility = []
    secretVisibility = [...showSecret]
    secretVisibility[index] = !showSecret[index]
    setShowSecret(secretVisibility)
  }

  const setProgramsTable = (oAuthPrograms) => {
    let programsTable = []
    oAuthPrograms.forEach((obj, index) => {
      let tableObj = [
        {
          id: 'programName',
          className: classes.tableClientName,
          value: <Box display="flex" justifyContent="space-between" alignItems="center" pr={2}>
            <Box>{_.get(obj, 'name', '-')}</Box>
          </Box>,
        },
        {
          id: 'programId',
          className: classes.tableProgramId,
          value: <Box display="flex" justifyContent="space-between" pr={2}>
            <Box mr={1}>{_.get(obj, 'program_key', '-')}</Box>
            <Tooltip title="copy" arrow placement="top-start"><img className={classes.tableIcons} src={copy} alt="" onClick={() => copyToClipboard(_.get(obj, 'program_key', '-'))} /></Tooltip>
          </Box>,
        },
        {
          id: 'oAuthClientId',
          className: classes.tableClientName,
          value: <Box display="flex" justifyContent="space-between" pr={2}>
            <Box mr={1}>{_.get(obj, 'oauth_client_id', '-')}</Box>
            <Tooltip title="copy" arrow placement="top-start"><img className={classes.tableIcons} src={copy} alt="" onClick={() => copyToClipboard(_.get(obj, 'oauth_client_id', '-'))} /></Tooltip>
          </Box>
        },
        {
          id: 'oAuthClientSecret',
          className: classes.tableClientSecret,
          value: <Box>
            {showSecret[index] ?
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>{_.get(obj, 'oauth_client_secret', '-')}</Box>
                <Box display="flex">
                  <Box display="flex" mx={1}><Tooltip title="hide" arrow placement="top-start"><img className={classes.tableIcons} src={hideeye} alt="" onClick={() => toggleSecretVisibility(index)} /></Tooltip></Box>
                  <Box display="flex" mx={1}><Tooltip title="copy" arrow placement="top-start"><img className={classes.tableIcons} src={copy} alt="" onClick={() => copyToClipboard(_.get(obj, 'oauth_client_secret', '-'))} /></Tooltip></Box>
                </Box>
              </Box> :
              <Box px={10}>
                <Tooltip title="show" arrow placement="top-start"><img className={classes.tableIcons} src={eye} alt="" onClick={() => { getClientSecret(obj.oauth_client_id, obj.id, index, oAuthPrograms) }} /></Tooltip>
              </Box>
            }
          </Box>
        }
      ]
      programsTable.push(tableObj)
    })
    setTableData(programsTable)
  }

  useEffect(() => {
    if (props.accountId) {
      filterPrograms()
      setShowSecret([])
    }
  }, [props.accountId])

  useEffect(() => {
    if (props.currentUser?.account_id)
      getAllPrograms()
  }, [props.currentUser])

  useEffect(() => {
    if (programs)
      setProgramsTable(programs)
  }, [programs, showSecret])

  return (
    <>
      <Loader loading={loading && !props.loading} />
      <Box className={classes.apiKeyBox} display="flex" flexWrap="wrap">
        <Box display="flex" mx={1} alignItems="center"><Typography className={classes.apiKey}>OAUTH URL</Typography>
          <InfoOutlined style={{ color: '#707070', fontSize: 18, cursor: 'pointer' }} onClick={handleInfoClick} />
          <Popover
            id={infoId}
            open={openInfo}
            anchorEl={infoAnchorEl}
            onClose={handleInfoClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            PaperProps={{
              className: classes.infoPopoverPaper,
            }}
          >
            <Box className={classes.infoPopover} p={1.5}>
              {'Unique URL to access the OAuth page'}
            </Box>
          </Popover>
        </Box>
        <Box display="flex" mx={1} alignItems="center"><Typography className={classes.apiKeyValue}>{oAuthUrl()}</Typography>
          {oAuthUrl() && <Tooltip title="copy" arrow placement="top-start"><img className={classes.tableIcons} src={copy} alt="" onClick={() => copyToClipboard(oAuthUrl())} /></Tooltip>}
        </Box>
      </Box>
      <TableOutline
        tableHeadings={programOAuthTableHeadings()}
        tableData={tableData}
        pagination={false}
      />
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin } = auth
  return { currentUser, isSuperAdmin }
}

export default connect(mapStateToProps, {})(ProgramOAuth)